/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { render } from 'react-dom';
import { initialize } from './components/global/Sentry/sentryConfig';
import routeConfiguration from './routeConfiguration';

import 'normalize.css/normalize.css';
import '@blend/shared-react/assets/blend-icons.css';
import './assets/fonts/RobotoMono.scss';
import './assets/fonts/TiemposHeadline.scss';
import './assets/fonts/UntitledSans.scss';

import './style/index.scss';
import { getConfig, loadConfig } from './utils/configs';
import { initAppcuesScript } from './api/appcues';
import { setupTwilioLogger } from '@utils/logger';
import { initDatadogRum } from '@utils/datadogRum';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
(async () => {
  await loadConfig();
  initDatadogRum();
  setupTwilioLogger();
  initAppcuesScript();

  if (window.location.hostname !== 'localhost') {
    initialize({
      // The following is the DSN for Sentry project #ron-client
      dsn: `https://dea127da036044c3a2245805cd581c5d@${getConfig().sentrySaasHost}/6139425`,
    });
  }

  render(routeConfiguration, document.getElementById('root'));
})();
